import {useRecommendedContext} from "../../../context/recommended/RecommendedContext";
import {Box} from "@mui/system";
import {TextField} from "@mui/material";
import RecommendedSettingDropdown from "./RecommendedSettingDropdown";
import {COLORS} from "../../../ui/Theme";
import AddIcon from "@mui/icons-material/Add";
import RecommendedSettingDelete from "./RecommendedSettingDelete";

const RecommendedSettingFormMobile = ({handleOpenAddModal}) => {
    const {
        config,
        tableData,
        editedName,
        setEditedName,
    } = useRecommendedContext();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "column",
                width: "100%",
                gap: "14px",
            }}
        >

            {/* Add Button */}
            <button
                className={
                    config.isValidating || tableData.isValidating
                        ? "btn btn-disable"
                        : "btn btn-blue"
                }
                onClick={handleOpenAddModal}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    color:
                        config.isValidating || tableData.isValidating
                            ? COLORS.GRAY
                            : COLORS.WHITE,
                }}
            >
                تنظیمات جدید
                <AddIcon
                    sx={{
                        color:
                            config.isValidating || tableData.isValidating
                                ? COLORS.GRAY
                                : COLORS.WHITE,
                    }}
                />
            </button>

            {/* Dropdown and Buttons */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    gap: "10px",
                }}
            >
                {/* Dropdown */}
                <RecommendedSettingDropdown sx={{marginLeft: "auto"}}/>

                {/* Delete Button */}
                <RecommendedSettingDelete/>
            </Box>

            {/* TextField */}
            <TextField
                value={config.isValidating || tableData.isValidating ? "" : editedName}
                onChange={(e) => setEditedName(e.target.value)}
                placeholder={
                    config.isValidating || tableData.isValidating
                        ? "در حال بارگذاری..."
                        : "نام تنظیمات..."
                }
                disabled={config.isValidating || tableData.isValidating}
                sx={{
                    width: "100%",
                    height: "46px",
                }}
            />
        </Box>
    );
};

export default RecommendedSettingFormMobile;